export default {
  props:["Show_dialog", "Conf_type", "Headline1", "Message1", "Headline2", "Message2", 'SubMessage'],
  data () {
    return {
      agree_count: 1
    }
  },
  computed: {
    dialog: {
      get: function () {
        return this.Show_dialog
      },
      set: function (value) {
        this.$emit('dialogClosed', value)
      }
    }
  },
  methods: {
    /*
    * agree
    * */
    agree() {
      if(this.Conf_type == 2 && this.agree_count < 2) {
        this.agree_count += 1;

      }else {
        this.agree_count = 1;
        this.$emit('agree', true);
        this.dialog = false;
      }
    },
    /*
    * disagree
    * */
    disagree() {
      this.agree_count = 1;
      this.dialog = false;
    }
  }
}